import CreateAmazonIdeaPage from "../components/amazon-idea/create-amazon-idea-page";
import UpdateAmazonIdeaPage from "../components/amazon-idea/update-amazon-idea-page";
import MainLayout from "../layout/MainLayout";
import EditProductCampaign from "../pages/seller/EditProductCampaign";
import EditProductPageV2 from "../pages/seller/EditProductV2";
import { OrdersPagePolaris } from "../pages/seller/OrdersPagePolaris";
import { OrdersPagePolaris2 } from '../pages/seller/OrdersPagePolaris2';
import { ProductsPagePolaris } from "../pages/seller/ProductsPagePolaris";
import AmazonIdeaPage from "../pages/seller/amazon-idea.page";
import { TEAM_ROLE, USER_ROLE } from "../variable";

const pathname = "/channel-supporter";
export default [
    {
        path: `${pathname}/amazon-ideas`,
        exact: true,
        component: AmazonIdeaPage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSupporter,
    },

    // {
    //     path: `${pathname}/amazon-ideas/create`,
    //     exact: true,
    //     component: CreateAmazonIdeaPage,
    //     layout: MainLayout,
    //     roles: [USER_ROLE.Seller],
    //     teamRole: TEAM_ROLE.ChannelSupporter,
    // },
    // {
    //     path: `${pathname}/amazon-ideas/:id/update`,
    //     exact: true,
    //     component: UpdateAmazonIdeaPage,
    //     layout: MainLayout,
    //     roles: [USER_ROLE.Seller],
    //     teamRole: TEAM_ROLE.ChannelSupporter,
    // },
    {
        path: `${pathname}/products`,
        exact: true,
        component: ProductsPagePolaris,
        layout: MainLayout,
        title: "Products",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSupporter,
    },
    {
        path: `${pathname}/products/edit/:id`,
        exact: true,
        component: EditProductPageV2,
        layout: MainLayout,
        title: "Edit Product",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSupporter,
    },
    {
        path: `${pathname}/products/campaign/:id`,
        exact: true,
        component: EditProductCampaign,
        layout: MainLayout,
        title: "Edit Product Campaign",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSupporter,
    },
    {
        path: `${pathname}/orders2`,
        exact: true,
        component: OrdersPagePolaris,
        layout: MainLayout,
        title: "Orders",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSupporter,
    },
    {
        path: `${pathname}/orders`,
        exact: true,
        component: OrdersPagePolaris2,
        layout: MainLayout,
        title: "Orders",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSupporter,
    },
];
